import React from 'react';
import { FiExternalLink } from 'react-icons/fi';
import RocketIcon from './RocketIcon';
import './ResumeLaunch.css';

const RESUME_URL = 'https://pdflink.to/daniel-mathews-resume/';

const ResumeLaunch = ({ variant = 'hero' }) => (
  <a
    href={RESUME_URL}
    target="_blank"
    rel="noopener noreferrer"
    className={`resume-launch resume-launch--${variant}`}
    aria-label="Open Daniel Mathews resume PDF in a new tab"
  >
    <span className="resume-launch__glow" aria-hidden="true" />
    <span className="resume-launch__rocket-wrap" aria-hidden="true">
      <RocketIcon size={variant === 'nav' ? 22 : 28} className="resume-launch__rocket" />
      <span className="resume-launch__exhaust" />
    </span>
    <span className="resume-launch__content">
      <span className="resume-launch__label">View Resume</span>
      {variant === 'hero' && (
        <span className="resume-launch__meta">Daniel Mathews · PDF</span>
      )}
    </span>
    <FiExternalLink className="resume-launch__icon" size={variant === 'nav' ? 16 : 18} />
  </a>
);

export default ResumeLaunch;
